export var placeorderGeneric = {
  message_name: 'place order system error',
  message_detail: 'Sorry, there was a system error. Your account has not been charged. Please try again later.'
};
export var mopGeneric = {
  message_name: 'payment processing issue',
  message_detail: 'There was an issue while processing your payment information. Your account has not been charged. Please try again or use different payment method.',
  message_id: 'mop.generic' //replace with actual error
};

export var couponGeneric = {
  message_name: 'coupon application issue',
  message_detail: 'Invalid coupon.'
};
export var paypalError = {
  message_name: 'PayPal declined error',
  message_detail: 'PayPal Payment Declined - Please verify your information or use different payment method.'
};

//[pmt1000,pmt1013,pmt1017,pmt2009,pmt2010,pmt2011,pmt2028,pmt2035,pmt30301,pmt2000,pmt500 ]
export var invalidPaymentInfo = {
  message_name: 'card declined - invalid payment info ',
  message_detail: 'Unable to save card - Invalid payment information. Please verify and enter again or try another card.'
};
//pmt1001,pmt1002,pmt1003  - message updated #22
export var insufficientFundsLimitExceeded = {
  message_name: 'card declined - insufficient funds / limit exceeded',
  message_detail: 'Card Declined - Insufficient Funds. If you believe this is an error, please contact your financial institution or try another card.'
};
//pmt1001-MM,pmt1002-MM
export var insufficientFundsLimitExceededMultiMonth = {
  message_name: 'card declined - insufficient funds',
  message_detail: 'Unable to process payment due to insufficient funds. Please add a new payment method, switch your plan, or contact your financial institution for help.'
};
//pmt1005,pmt30026,pmt20005,pmt20023 - message updated - #17
export var unsupported = {
  message_name: 'card declined - unsupported card',
  message_detail: 'We don’t accept this type of card. Please add another payment method and try again.'
};
//pmt1021,pmt2008,pmt2013,pmt2014,pmt2027,pmt2029
export var byInstitution = {
  message_name: 'card declined - by financial institution',
  message_detail: 'Card Declined - The transaction is declined. Please contact your financial institution or try another card.'
};
//pmt2001,pmt30221 -- message updated - #11
export var expired = {
  message_name: 'card declined - expired card',
  message_detail: 'This card has expired. Please add another payment method and try again.'
};
//pmt2002,pmt2033  -- message updated = #27
export var invalidNumber = {
  message_name: 'card declined - invalid card number',
  message_detail: 'Incorrect card number. Please double-check your payment information and try again.'
};
//pmt2003,pmt30220
export var invalidExpDate = {
  message_name: 'card declined - invalid expiration',
  message_detail: 'Card Declined - The transaction is declined due to invalid expiration date.  Please verify and enter again or try another card.'
};
//pmt2007,pmt2039
export var invalidGeneric = {
  message_name: 'card declined - generic error',
  message_detail: 'Card Declined - Please verify your Credit Card Number, Expiration Date, Security Code and try again.'
};

//pm-003
export var inlineFormError = {
  message_name: 'please complete all required fields',
  message_detail: 'Please complete all required fields.'
};

// message updated - #25
export var insufficientFundsActivityLimitExceeded = {
  message_name: 'card declined - insufficient funds / activity limit exceeded',
  message_detail: "Oops! It looks like you\u2019ve reached your daily limit for this card. Please provide a different payment method or contact your financial institution for assistance."
};

// message updated - #25 pmt1003-MM
export var insufficientFundsActivityLimitExceededMultiMonth = {
  message_name: 'card declined - insufficient funds / activity limit exceeded',
  message_detail: "It looks like you've reached your daily limit for this card. Please add a new payment method, switch your plan, or contact your financial institution for help."
};

/*
  Checkout BFF Errors - https://chegg.atlassian.net/wiki/spaces/LST/pages/2441778293/Cart+Checkout+Service+Error+Details
*/

//CSDK-003 - we assume that bad request errors coming from the BFF may be due to address which does not pass validation.
export var inccorectPostalCode = {
  message_name: 'bad request - billing info',
  message_detail: "Zip/Postal code is either incorrect or doesn't match selected country."
};

//CB-0801, CB-BFF-001
export var circuitBreaker = {
  message_name: 'generic circuit breaker',
  message_detail: "Something's not right. Our team is working on it. Please come back later and try again."
};

//PROMO-VAL-0601 - not currently utilized by coupon component
export var unrecognizedCoupon = {
  message_name: 'unrecognized coupon',
  message_detail: 'We don’t recognize this code.'
};

//PROMO-VAL-0602 - not currently utilized by coupon component
export var expiredCoupon = {
  message_name: 'expired coupon',
  message_detail: 'This code is no longer valid.'
};

//CARTITEM-VAL-0201
export var cartWithNoItems = {
  message_name: 'bad cart - no items',
  message_detail: 'No items to checkout.'
};

//CART-VAL-0101
export var unrecoverableCart = {
  message_name: 'bad cart - unrecoverable',
  message_detail: "Something's not right. Please refresh and try again."
};

//MOP-VAL-0301
export var noPaymentMethods = {
  message_name: 'bad cart - missing payment methods',
  message_detail: 'Please add a payment method.'
};

// message updated - #1
export var DoNotHonorFraud = {
  message_name: 'Do not honor - Fraud',
  message_detail: 'Unable to process payment. Please provide a different payment method or contact your financial institution for assistance.'
};

// message updated - #7
export var declinedInvalidPaymentInfoDoNotHonor = {
  message_name: 'Declined - Invalid payment info - Do not honor',
  message_detail: 'Unable to process payment. Please verify your information is correct, try another card, or contact your financial institution for assistance.'
};

// message updated - #6
export var declinedInvalidPaymentInfoFraudSuspected = {
  message_name: 'Declined - Invalid payment info - Fraud suspected',
  message_detail: 'Unable to process payment. Please provide a different payment method or contact your financial institution for assistance.'
};

// message updated = #8
export var declinedInvalidPaymentInfoProcessDeclined = {
  message_name: 'Declined - Invalid payment info - Processor declined',
  message_detail: 'Unable to process payment. Please verify your information is correct, try another card, or contact your financial institution for assistance.'
};

// message updated - #16
export var restrictionOnCard = {
  message_name: 'Restriction on card',
  message_detail: 'Unable to process payment. Please provide a different payment method or contact your financial institution for assistance.'
};

// message updated - #5
export var incorrectCVV = {
  message_name: 'Incorrect CVV',
  message_detail: 'Incorrect CVV. Please double-check your payment information and try again.'
};

// message updated - #23
export var paymentProcessingIssueCanNotUsePaymentMoreThanOnce = {
  message_name: 'Payment processing issue - Cannot use payment more than once',
  message_detail: 'Unable to process payment. Please provide a different payment method or contact your financial institution for assistance.'
};

// message updated - #3
export var duplicateCard = {
  message_name: 'Duplicate card',
  message_detail: 'This card has already been added. Please provide a different payment method and try again.'
};

// message updated - #9
export var paymentProcessingIssueTransactionNotAllowed = {
  message_name: 'Payment processing issue - Transaction not allowed',
  message_detail: 'Unable to process payment. Please verify your information is correct, try another card, or contact your financial institution for assistance.'
};

// message updated - #10
export var paymentProcessingIssueCallIssuerPickUpCard = {
  message_name: 'Payment processing issue - Call issuer pick up card',
  message_detail: 'Unable to process payment. Please verify your information is correct, try another card, or contact your financial institution for assistance.'
};

// message updated - #12
export var paymentProcessingIssueInvalidTransaction = {
  message_name: 'Payment processing issue - Invalid transaction',
  message_detail: 'Unable to process payment. Please verify your information is correct, try another card, or contact your financial institution for assistance.'
};

// message updated - #13
export var paymentProcessingIssueNoAccount = {
  message_name: 'Payment processing issue - No account',
  message_detail: 'Unable to process payment. Please verify your information is correct, try another card, or contact your financial institution for assistance.'
};

// message updated - #14
export var paymentProcessingIssueSecurityViolation = {
  message_name: 'Payment processing issue - Security violation',
  message_detail: 'Unable to process payment. Please verify your information is correct, try another card, or contact your financial institution for assistance.'
};

// message updated - #15
export var paymentProcessingIssueDeclined = {
  message_name: 'Payment processing issue - Declined',
  message_detail: 'Unable to process payment. Please verify your information is correct, try another card, or contact your financial institution for assistance.'
};

// message updated - #19
export var paymentProcessingIssueTokenInvalid = {
  message_name: 'Payment processing issue - Token invalid',
  message_detail: 'Something went wrong! Please try again or contact support.'
};

// message updated - #20
export var paymentProcessingIssueViolation = {
  message_name: 'Payment processing issue - Violation',
  message_detail: 'Unable to process payment. Please verify your information is correct, try another card, or contact your financial institution for assistance.'
};

// message updated - #21
export var paymentProcessingIssueDuplicateTransaction = {
  message_name: 'Payment processing issue - Duplicate transaction',
  message_detail: 'Oops! This appears to be a duplicate transaction, you have not been charged. For additional assistance, please contact us.'
};

// message updated - #24
export var paymentProcessingIssueInvalidMerchantId = {
  message_name: 'Payment processing issue - Invalid merchant id',
  message_detail: 'Something went wrong! Please try again or contact support.'
};

// message updated - #26
export var paymentProcessingIssueCustomerIdAlreadyTaken = {
  message_name: 'Payment processing issue - Customer id already taken',
  message_detail: 'Something went wrong! Please try again or contact support.'
};

// message updated - #28
export var paymentProcessingIssueProcessorNetworkUnavailable = {
  message_name: 'Payment processing issue - Processor network unavailable',
  message_detail: 'Something went wrong! Please try again or contact support.'
};
export var cardNumberRequired = {
  message_name: 'Card number required',
  message_detail: 'Card number is required.'
};
export var billingAddressFailed = {
  message_name: 'unable to create billing address',
  message_detail: 'Unable to create billing address.'
};
export var invalidBillingAddress = {
  message_name: 'card declined - unable to verify billing address',
  message_detail: 'Card Declined - Please verify your billing address and try again or use another card.'
};
export var cvvLength = {
  message_name: 'cvv must be 3 or 4 digits',
  message_detail: 'CVV must be 3 or 4 digits.'
};
export var systemGeneric = {
  message_name: 'checkout - system error',
  message_detail: 'Sorry, there was a system error. Please try again later.'
};
export var noCheggCredit = {
  message_name: 'user does not have chegg credit',
  message_detail: 'User do not have chegg credit.'
};
export var secCodeRequired = {
  message_name: 'security code is required',
  message_detail: 'Security code is required.'
};
export var secCodeLength4 = {
  message_name: 'security code should be 4 digits',
  message_detail: 'Security Code should be 4 digits.'
};
export var secCodeLength3 = {
  message_name: 'security code should be 3 digits',
  message_detail: 'Security Code should be 3 digits.'
};
export var nameOnCardRequired = {
  message_name: 'name on card is required',
  message_detail: 'Name on card is required.'
};
export var cardNumberLength14 = {
  message_name: 'card number is less than 14 digits',
  message_detail: 'Card number is less than 14 digits.'
};
export var cardNumberLength18 = {
  message_name: 'card number is less than 18 digits',
  message_detail: 'Card number is less than 18 digits.'
};
export var cardNumberLength12 = {
  message_name: 'Credit card number must be 12-19 digits.',
  message_detail: 'Credit card number must be 12-19 digits.'
};
export var invalidYifteeCode = {
  message_name: 'invalid Yiftee code',
  message_detail: 'Invalid Yiftee code.'
};
export var yifteeFailed = {
  message_name: 'unable to redeem Yiftee - misentered',
  message_detail: 'We are unable to redeem your gift certificate. Please make sure it was entered correctly.'
};
export var yifteeExpired = {
  message_name: 'unable to redeem Yiftee - expired or redeemed',
  message_detail: 'We are unable to redeem your gift certificate. It is either expired or redeemed.'
};
export var noPaypalAccount = {
  message_name: 'user does not have a paypal account',
  message_detail: 'User does not have a PayPal account.'
};
export var cardOnMultipleAccounts = {
  message_name: 'card is associated with multiple accounts',
  message_detail: 'This card is associated with another account and for safety reasons, cannot be added. Please add a different payment method or contact support.'
};
export var itemOnAnotherOrder = {
  message_name: 'Item is already ordered.',
  message_detail: 'This item is already ordered in another order.'
};
export var noCarts = {
  message_name: 'Try refreshing the page or come back later.',
  message_detail: 'Try refreshing the page or come back later.'
};
export var fraudRiskCheck = {
  message_name: 'Fraud Risk Check',
  message_detail: 'There was an issue while processing your payment information. Your account has not been charged. Please try again, use different payment method, or turn off VPN connections and refresh the page.'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/constants/ServerErrors.js
// module id = 1379
// module chunks = 11